<div class="col-12">
  <div class="grid">
    <div class="col-3">
      <h5 style="text-transform: unset !important">Material Search</h5>
    </div>
    <div class="col-6">
      <h5 class="pt-4"
        style="text-transform: unset !important;font-style: italic;color:#ef4d5b;font-weight: 600;font-size: 1.0rem !important;">
        If you are placing a sample order that
        was forecasted
        using
        FARM,<br />please search for the forecast by
        selecting the 'My Forecasts' tab above.</h5>
    </div>
    <div class="col-3" style="text-align: right;flex-direction: column;display: flex;">
      <a target="_blank" style="text-decoration: underline;" href="{{compositeSearchSettings.factsUrl}}">*FACTS</a>
      <a target="_blank" style="text-decoration: underline;" href="{{compositeSearchSettings.coreUrl}}">*Compound
        Utilities</a>
      <a target="_blank" style="text-decoration: underline;" href="{{compositeSearchSettings.raceUrl}}">*RACE</a>
      <span style="font-weight: bold;">*Requires VPN</span>
    </div>
  </div>
  <div class="grid">
    <div class="col-12" style="display: inline-flex;">

      <div class="clsRequestType" [ngClass]="{'clsBlue' :  RequestTypeName ==  requestType?.InStock}">
        <p-radioButton label='Stock' [disabled]="disableRequestType" name="requestType" value="{{requestType?.InStock}}"
          [(ngModel)]="RequestTypeName" (ngModelChange)="searchLaneChanged();"></p-radioButton>
      </div>
      <div class="clsRequestType"
        [ngClass]="{'clsBlue' :  RequestTypeName == requestType?.GLP , 'clsDisabled' :  !isGlpEligible }">
        <p-radioButton label='GLP' [disabled]="disableRequestType || !isGlpEligible" name="requestType"
          value="{{requestType?.GLP}}" [(ngModel)]="RequestTypeName" (ngModelChange)="searchLaneChanged();">
        </p-radioButton>
      </div>      
      <div class="clsRequestType" [ngClass]="{'clsBlue' :  RequestTypeName == requestType?.PeerToPeer}">
        <p-radioButton label='P2P' [disabled]="disableRequestType" name="requestType"
          value="{{requestType?.PeerToPeer}}" [(ngModel)]="RequestTypeName" (ngModelChange)="searchLaneChanged();">
        </p-radioButton>
      </div>
    </div>

  </div>
  <div class="grid" style="border: 4px solid black; margin-top: 30px; margin-bottom: 30px;">
    <div class="col-1" *ngIf="RequestTypeName == requestType?.GLP"></div>
    <div class="col-2" *ngIf="RequestTypeName != requestType?.GLP">
      <div class="col-12" *ngIf="RequestTypeName != requestType?.GLP">
        <span style='font-weight:600'>Co-Formulants</span>
      </div>
      <div class="col-12" *ngIf="RequestTypeName != requestType?.GLP">
        <p-radioButton label='Co-Formulant' name="materialTypeId" value="1" [(ngModel)]="materialTypeId"
          (click)="onTypeChange();"></p-radioButton>
      </div>
      <div class="col-12" *ngIf="RequestTypeName != requestType?.GLP">
        <p-radioButton label='Field Inert' name="materialTypeId" value="2" [(ngModel)]="materialTypeId"
          (click)="onTypeChange();"></p-radioButton>
      </div>
    </div>
    <div class="col-3">
      <div class="col-12">
        <span style='font-weight:600'>Biological & Chemical Formulations</span>
      </div>
      <div class="col-12" *ngIf="RequestTypeName != requestType?.GLP">
        <p-radioButton label='FACTS Formulation ID' name="materialTypeId" value="3" [(ngModel)]="materialTypeId"
          (click)="onTypeChange();"></p-radioButton>
      </div>
      <div class="col-12" *ngIf="RequestTypeName != requestType?.GLP">
        <p-radioButton label='Synonym' name="materialTypeId" value="4" [(ngModel)]="materialTypeId"
          (click)="onTypeChange();"></p-radioButton>
      </div>
      <div class="col-12" *ngIf="RequestTypeName != requestType?.GLP">
        <p-radioButton label='Corteva Trade Name' name="materialTypeId" value="5" [(ngModel)]="materialTypeId"
          (click)="onTypeChange();"></p-radioButton>
      </div>
      <div class="col-12" *ngIf="RequestTypeName != requestType?.GLP">
        <p-radioButton label='3rd Party Trade Name' name="materialTypeId" value="6" [(ngModel)]="materialTypeId"
          (click)="onTypeChange();"></p-radioButton>
      </div>
      <div class="col-12" *ngIf="isGlpEligible && RequestTypeName != requestType?.InStock">
        <p-radioButton label='FACTS Formulation ID (GLP)' name="materialTypeId" value="7" [(ngModel)]="materialTypeId"
          (click)="onTypeChange();"></p-radioButton>
      </div>
      <div class="col-12" *ngIf="isGlpEligible && RequestTypeName != requestType?.InStock">
        <p-radioButton label='TSN (GLP)' name="materialTypeId" value="12" [(ngModel)]="materialTypeId"
          (click)="onTypeChange();"></p-radioButton>
      </div>
    </div>
    <div class="col-3">
      <div class="col-12">
        <span style='font-weight:600'>Chemical Compounds/Technicals</span>
      </div>
      <div class="col-12" *ngIf="RequestTypeName != requestType?.GLP">
        <p-radioButton label='CORE Material ID' name="materialTypeId" value="8" [(ngModel)]="materialTypeId"
          (click)="onTypeChange();"></p-radioButton>
      </div>
      <div class="col-12" *ngIf="RequestTypeName != requestType?.GLP">
        <p-radioButton label='Synonym' name="materialTypeId" value="9" [(ngModel)]="materialTypeId"
          (click)="onTypeChange();"></p-radioButton>
      </div>
      <div class="col-12" *ngIf="isGlpEligible  && RequestTypeName != requestType?.InStock">
        <p-radioButton label='CORE Lot ID (GLP)' name="materialTypeId" value="10" [(ngModel)]="materialTypeId"
          (click)="onTypeChange();"></p-radioButton>
      </div>
      <div class="col-12" *ngIf="isGlpEligible  && RequestTypeName != requestType?.InStock">
        <p-radioButton label='TSN (GLP)' name="materialTypeId" value="11" [(ngModel)]="materialTypeId"
          (click)="onTypeChange();"></p-radioButton>
      </div>
    </div>
    <div class="col-2">
      <div class="col-12">
        <span style='font-weight:600'>Biological Actives</span>
      </div>
      <div class="col-12" *ngIf="RequestTypeName != requestType?.GLP">
        <p-radioButton label='Bionexus Material ID' name="materialTypeId" value="17" [(ngModel)]="materialTypeId"
          (click)="onTypeChange();"></p-radioButton>
      </div>
      <div class="col-12" *ngIf="RequestTypeName != requestType?.GLP">
        <p-radioButton label='Synonym' name="materialTypeId" value="18" [(ngModel)]="materialTypeId"
          (click)="onTypeChange();"></p-radioButton>
      </div>
      <div class="col-12" *ngIf="isGlpEligible  && RequestTypeName != requestType?.InStock">
        <p-radioButton label='Bionexus Material Lot ID (GLP)' name="materialTypeId" value="15" [(ngModel)]="materialTypeId"
          (click)="onTypeChange();"></p-radioButton>
      </div>
      <div class="col-12"
        *ngIf="isGlpEligible  && RequestTypeName != requestType?.InStock && RequestTypeName != requestType?.PeerToPeer">
        <p-radioButton label='Synonym' name="materialTypeId" value="16" [(ngModel)]="materialTypeId"
          (click)="onTypeChange();"></p-radioButton>
      </div>
    </div>
    <div class="col-2" *ngIf="RequestTypeName == requestType?.PeerToPeer">
      <div class="col-12">
        <span style='font-weight:600'>Other (Peer To Peer)</span>
      </div>
      <div class="col-12">
        <p-radioButton label='P2P/Chemical' name="materialTypeId" value="19" [(ngModel)]="materialTypeId"
          (click)="onTypeChange();"></p-radioButton>
      </div>
      <div class="col-12">
        <p-radioButton label='P2P/Biological' name="materialTypeId" value="13" [(ngModel)]="materialTypeId"
          (click)="onTypeChange();"></p-radioButton>
      </div>
      <div class="col-12">
        <p-radioButton label='P2P/Other (equipment, etc.)' name="materialTypeId" value="14" [(ngModel)]="materialTypeId"
          (click)="onTypeChange();"></p-radioButton>
      </div>

    </div>
  </div>
  <div class="grid" style='padding-top:10px;'>
    <div class='col-12' style="display: flex; justify-content: center;"
      *ngIf="materialType!=='P2PBiological'&&materialType!=='P2POther' &&materialType!=='P2PChemical'">
      <span style='font-weight:600'>{{getSearchLabelText()}}</span>
    </div>
    <div class='col-12' style='display: flex; justify-content: center;'
      *ngIf="materialType!=='FACTSFormulationName'&&materialType!=='FACTSFormulationNameGlp'&&materialType!=='P2PBiological'&&materialType!=='P2POther' && materialType!=='P2PChemical'">
      <div class="grid">
        <div class='col-9'>
          <input #txtSearch (keypress)="RestrictUnwantedCharecters($event)" [(ngModel)]="searchText" type="text"
            class="searchTextBox3" pInputText tabindex="0" (keyup.enter)="search()">
        </div>
        <div class='col-3' style="text-align: end;">
          <i aria-hidden="true" title="Search" class="fa fa-search fa-2x"
            style="margin-left:-10px;margin-top:5px;color:blue;cursor:pointer" (click)="search()"></i>

        </div>
      </div>
    </div>
    <div class='col-12' style='display: flex; justify-content: center;'
      *ngIf="materialType==='P2PBiological' || materialType==='P2POther' || materialType==='P2PChemical'">
      <div class="grid" style="width: 100% !important;">
        <div class='col-12'>
          <span style='font-weight:600'>Add {{getSearchLabelText()}}</span>
        </div>
        <div></div>

        <div class="col-12 ui-dataview-content ui-widget-content">
          <div class="col-12">
            <div class="grid resShadow ">
              <div class="col-10">
                <div class='col-12'>
                  *Material Name: <input #txtSearch (keypress)="RestrictUnwantedCharecters($event)" maxlength="50"
                    [(ngModel)]="searchText" type="text" class="searchTextBox3" pInputText tabindex="0"
                    (change)="OnTextChanged($event)" (paste)="onMaterialNamePaste($event)"
                    placeholder="Enter {{getSearchLabelText()}} here">
                </div>
              </div>
              <div class="col-2">
                <div>
                  <div class="col-12">
                    <button pButton type="button" icon="pi pi-shopping-cart" label="Add to Cart"
                      (click)="addToCartP2P()" class="p-button-success float-right"
                      [disabled]="!searchText || p2pDisabled">
                    </button>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class='col-12' style='display: flex; justify-content: center;' *ngIf="materialType==='FACTSFormulationName'">
      <div class="grid" style='margin-left:100px;'>
        <div class='col-3'>
          <div class='col-12' style='display: flex; justify-content: center;'>
            <span>
              <h6>AiC*</h6>
            </span>
          </div>
          <div class='col-12'>
            <input #txtAiC [(ngModel)]="aiC" (keypress)="AllowAlphaNumeric($event)" type="text" class="searchTextBox"
              pInputText tabindex="0" (keyup.enter)="search()">
          </div>
        </div>
        <div class='col-3'>
          <div class='col-12' style='display: flex; justify-content: center;'>
            <span>
              <h6>Concept*</h6>
            </span>
          </div>
          <div class='col-12'>
            <input #txtConcept [(ngModel)]="concept" (keypress)="AllowOnlyNumeric($event)" type="text"
              class="searchTextBox" pInputText tabindex="0" (keyup.enter)="search()">
          </div>
        </div>
        <div class='col-3'>
          <div class='col-12' style='display: flex; justify-content: center;'>
            <span>
              <h6>Composition*</h6>
            </span>
          </div>
          <div class='col-12'>
            <input #txtComposition [(ngModel)]="composition" (keypress)="AllowOnlyNumeric($event)" type="text"
              class="searchTextBox" pInputText tabindex="0" (keyup.enter)="search()">
          </div>
        </div>
        <div class='col-3'>
          <div class='col-12'>
          </div>
          <div class='col-12'>
            <i aria-hidden="true" title="Search" class="fa fa-search fa-2x"
              style="color:blue;margin-top: 40px;margin-left:0px;cursor:pointer" (click)="search()"></i>
          </div>
        </div>
      </div>
    </div>
    <div class='col-12' style='display: flex; justify-content: center;'
      *ngIf="materialType==='FACTSFormulationNameGlp'">
      <div class="grid" style='margin-left:100px;'>
        <div class='col-2'>
          <div class='col-12' style='display: flex; justify-content: center;'>
            <span>
              <h6>AiC*</h6>
            </span>
          </div>
          <div class='col-12'>
            <input #txtAiC [(ngModel)]="aiC" (keypress)="AllowAlphaNumeric($event)" maxlength="10" type="text"
              class="searchTextBox2" pInputText tabindex="0" (keyup.enter)="search()">
          </div>
        </div>
        <div class='col-2' style="margin-left:15px;">
          <div class='col-12' style='display: flex; justify-content: center;'>
            <span>
              <h6>Concept*</h6>
            </span>
          </div>
          <div class='col-12'>
            <input #txtConcept [(ngModel)]="concept" (keypress)="AllowOnlyNumeric($event)" type="text"
              class="searchTextBox2" pInputText tabindex="0" (keyup.enter)="search()">
          </div>
        </div>
        <div class='col-2' style="margin-left:15px;">
          <div class='col-12' style='display: flex; justify-content: center;'>
            <span>
              <h6>Composition*</h6>
            </span>
          </div>
          <div class='col-12'>
            <input #txtComposition [(ngModel)]="composition" (keypress)="AllowOnlyNumeric($event)" type="text"
              class="searchTextBox2" pInputText tabindex="0" (keyup.enter)="search()">
          </div>
        </div>
        <div class='col-2' style="margin-left:15px;">
          <div class='col-12' style='display: flex; justify-content: center;'>
            <span>
              <h6>Lot*</h6>
            </span>
          </div>
          <div class='col-12'>
            <input #txtLot [(ngModel)]="lotNumber" (keypress)="AllowOnlyNumeric($event)" type="text"
              class="searchTextBox2" pInputText tabindex="0" (keyup.enter)="search()">
          </div>
        </div>
        <div class='col-3'>
          <div class='col-12'>
          </div>
          <div class='col-12'>
            <i aria-hidden="true" title="Search" class="fa fa-search fa-2x"
              style="color: blue;margin-top: 40px;margin-left:0px;cursor:pointer" (click)="search()"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class='col-12' *ngIf="materialType!=='P2PBiological'&&materialType!=='P2POther' && materialType!=='P2PChemical'">
  Search Results
</div>
<div class='col-12' *ngIf="materialType!=='P2PBiological'&&materialType!=='P2POther' && materialType!=='P2PChemical'">
  <p-dataView #dv layout="list" [paginator]="true" [rows]="5" [value]="results" paginatorPosition="both"
    [hidden]="isHidden" pageLinks="3" [alwaysShowPaginator]="true" styleClass="hover search">
    <!-- </p-header> -->
    <ng-template let-result pTemplate="listItem">
      <div class="col-12 ui-dataview-content ui-widget-content">
        <div class="col-12"
          *ngIf="result.status != 'DISCONTINUED' || (result.status == 'DISCONTINUED' && (result.quantity && result.quantity >= 0))">
          <div class="grid resShadow ">
            <div class="col-9">
              <div *ngIf="materialType==='Coformulant'" class="grid">
                <div class='col-12'>
                  <span style="padding-right: 5px;">Trade Name: {{result.tradeName}}</span>
                  <button pButton type="button" icon="pi pi-list" title="Click icon to view inventory"
                    (click)="getMaterialDetails('COFORM',result.materialIdInTargetSystem,'mL',getProductName(result))"
                    class="p-button-label"></button>

                </div>
                <div class='col-12'>
                  <span>Common Name: {{result.commonName}}</span>
                </div>
                <div class='col-12'>
                  <span>IUPAC: {{result.iupacName}}</span>
                </div>
              </div>
              <div *ngIf="materialType==='FieldInert'" class="grid">
                <div class='col-11'>
                  <div class='grid'>
                    <div class='col-12'>
                      <span style="padding-right: 5px;">Trade Name: {{result.tradeName}}</span>
                      <button pButton type="button" icon="pi pi-list" title="Click icon to view inventory"
                        (click)="getMaterialDetails('COFORM',result.materialIdInTargetSystem,'mL',getProductName(result))"
                        class="p-button-label"></button>
                    </div>
                    <div class='col-12'>
                      <span>Common Name: {{result.commonName}}</span>
                    </div>
                    <div class='col-12'>
                      <span>IUPAC: {{result.iupacName}}</span>
                    </div>
                  </div>
                </div>
                <div class="col-1">
                  <span><i class='fa fa-2x fa-flag' style="margin-top: 5px;"></i> Field Inert</span>
                </div>
              </div>

              <div
                *ngIf="materialType==='FACTSFormulationName'||materialType==='CortevaTradeName' ||materialType==='ThirdPartyTradeName'||materialType==='FACTSSynonym'"
                class="grid">
                <div class='col-12'>
                  <span style="padding-right: 5px;">Material Name: {{result.materialName}}</span>
                  <button pButton type="button" icon="pi pi-list" title="Click icon to view inventory"
                    (click)="getMaterialDetails('FACTS',result.materialIdInTargetSystem,'mL',getProductName(result))"
                    class="p-button-label"></button>
                </div>
                <div class='col-12'>
                  <span>Approver: <a *ngIf="result.approverEmail"
                      href="mailto:{{result.approverEmail}}">{{result.approverFullName == null ? result.approverEmail :
                      result.approverFullName}}</a> </span>
                </div>
                <div class='col-12'>
                  <span>Stage: {{result.stage}}</span>
                </div>
                <div class='col-12'>
                  <span>Formulation Type: {{result.formulationTypeCode}}</span>
                </div>
                <div class='col-12' style="padding-bottom: 0px !important;">
                  <span>Actives:</span>
                  <div class="col-12" *ngFor="let active of result.actives">
                    <div class="grid" style="padding-left: 50px;">
                      <div class="col-3" style="padding-top: 0px !important;padding-bottom:0px !important">
                        {{active.ingredientName}}</div>
                      <div class="col-2" style="padding-top: 0px !important;padding-bottom:0px !important">
                        {{active.concentrationPrimaryUom}}</div>
                      <div class="col-2" style="padding-top: 0px !important;padding-bottom:0px !important">
                        {{active.concentrationSecondaryUom}}</div>
                    </div>
                  </div>
                </div>
                <div class='col-12'>
                  <span>Synonym:</span>
                  <div class="col-12" *ngFor="let synonym of result.synonyms">
                    <div class="grid" style="padding-left: 50px;">
                      <div class="col-12">{{synonym}}</div>
                    </div>
                  </div>
                </div>
              </div>

              <div *ngIf="materialType==='FACTSFormulationNameGlp'" class="grid">
                <div class='col-12'>
                  <span style="padding-right: 5px;">Formulation ID: {{result.lotNumber }}</span>
                  <button pButton type="button" icon="pi pi-list" title="Click icon to view inventory"
                    (click)="getMaterialDetails('FACTS',result.materialIdInTargetSystem,'mL',getProductName(result))"
                    class="p-button-label"></button>
                </div>
                <div class='col-12'>
                  <span>GLP Lot Approver: <a *ngIf="result.approverEmail"
                      href="mailto:{{result.approverEmail}}">{{result.approverFullName == null ? result.approverEmail :
                      result.approverFullName}}</a> </span>
                </div>
                <div class='col-12'>
                  <span>Stage: {{result.stage}}</span>
                </div>
                <div class='col-12'>
                  <span>Available Amount : {{result.quantity | number : '1.3-3'}} {{result.quantityUom}}</span>
                </div>

                <div class='col-12'>
                  <span>Certification Date: {{result.certificationDate | date: 'dd-MMM-yyyy'}}</span>
                </div>
                <div class='col-12'>
                  <span>RE-Certification Date: {{result.recertificationDate | date: 'dd-MMM-yyyy'}}</span>
                </div>
                <div class='col-12'>
                  <span>Formulation Type: {{result.formulationTypeCode}}</span>
                </div>
                <div class='col-12' style="padding-bottom: 0px !important;">
                  <span>Actives:</span>
                  <div class="col-12" *ngFor="let active of result.actives">
                    <div class="grid" style="padding-left: 50px;">
                      <div class="col-3" style="padding-top: 0px !important;padding-bottom:0px !important">
                        {{active.ingredientName}}</div>
                      <div class="col-2" style="padding-top: 0px !important;padding-bottom:0px !important">
                        {{active.concentrationPrimaryUom}}</div>
                      <div class="col-2" style="padding-top: 0px !important;padding-bottom:0px !important">
                        {{active.concentrationSecondaryUom}}</div>
                    </div>
                  </div>
                </div>
                <div class='col-12'>
                  <span>Synonym:</span>
                  <div class="col-12" *ngFor="let synonym of result.synonyms">
                    <div class="grid" style="padding-left: 50px;">
                      <div class="col-12">{{synonym}}</div>
                    </div>
                  </div>
                </div>
              </div>

              <div *ngIf="materialType==='FACTTSNGlp'" class="grid">
                <div class='col-12'>
                  <span>Formulation ID: {{result.lotNumber }}</span>
                </div>
                <div class='col-12'>
                  <span>GLP Lot Approver: <a *ngIf="result.approverEmail"
                      href="mailto:{{result.approverEmail}}">{{result.approverFullName == null ? result.approverEmail :
                      result.approverFullName}}</a></span>
                </div>
                <div class='col-12'>
                  <span>Stage: {{result.stage}}</span>
                </div>
                <div class='col-12'>
                  <span>TSN: {{result.tsn}}</span>
                </div>
                <div class='col-12'>
                  <span>Available Amount : {{result.quantity | number : '1.3-3'}} {{result.quantityUom}}</span>
                </div>
                <div class='col-12'>
                  <span>GLP Status : {{result.glpStatus}}</span>
                </div>
                <div class='col-12'>
                  <span>Purity: {{result.certifiedPurity}}</span>
                </div>
                <div class='col-12'>
                  <span>Certification Date: {{result.certificationDate | date: 'dd-MMM-yyyy'}}</span>
                </div>
                <div class='col-12'>
                  <span>RE-Certification Date: {{result.recertificationDate | date: 'dd-MMM-yyyy'}}</span>
                </div>
                <div class='col-12'>
                  <span>Formulation Type: {{result.formulationTypeCode}}</span>
                </div>
                <div class='col-12' style="padding-bottom: 0px !important;">
                  <span>Actives:</span>
                  <div class="col-12" *ngFor="let active of result.actives">
                    <div class="grid" style="padding-left: 50px;">
                      <div class="col-3" style="padding-top: 0px !important;padding-bottom:0px !important">
                        {{active.ingredientName}}</div>
                      <div class="col-2" style="padding-top: 0px !important;padding-bottom:0px !important">
                        {{active.concentrationPrimaryUom}}</div>
                      <div class="col-2" style="padding-top: 0px !important;padding-bottom:0px !important">
                        {{active.concentrationSecondaryUom}}</div>
                    </div>
                  </div>
                </div>
                <div class='col-12'>
                  <span>Synonym:</span>
                  <div class="col-12" *ngFor="let synonym of result.synonyms">
                    <div class="grid" style="padding-left: 50px;">
                      <div class="col-12">{{synonym}}</div>
                    </div>
                  </div>
                </div>
              </div>

              <div *ngIf="materialType==='COREMaterialId' || materialType==='CORESynonym'" class="grid"
                style="padding:10px">
                <div class='col-12'>
                  <span style="padding-right:5px;">Material Name: {{result.materialName}}</span>
                  <button pButton type="button" icon="pi pi-list" title="Click icon to view inventory"
                    (click)="getMaterialDetails('CORE',result.materialName,'mg',getProductName(result))"
                    class="p-button-label"></button>
                </div>
                <div class='col-12'>
                  <span>Approver: <a *ngIf="result.approverEmail"
                      href="mailto:{{result.approverEmail}}">{{result.approverEmail}}</a> </span>
                </div>
                <div class='col-12'>
                  <div class="col-12">
                    <span>Synonyms: </span>
                    <span *ngIf="result.synonyms" class="col-12">{{result.synonyms.join("; ")}}</span>
                  </div>
                </div>
              </div>
              <div *ngIf="materialType==='COREMaterialLotGlp' || materialType==='TsnGlp'" class="grid"
                style="padding:10px">
                <div class='col-12'>
                  <span style="padding-right:5px;">Material Name: {{result.materialName}}</span>
                  <button pButton type="button" icon="pi pi-list" title="Click icon to view inventory"
                    (click)="getMaterialDetails('CORE',result.materialName,'mg',getProductName(result))"
                    class="p-button-label"></button>
                </div>
                <div class='col-12'>
                  <span>GLP Lot Approver: <a *ngIf="result.approverEmail"
                      href="mailto:{{result.approverEmail}}">{{displayName}}</a> </span>
                </div>
                <div class='col-12'>
                  <span>Lot ID : {{result.lotId}}</span>
                </div>

                <div class='col-12'>
                  <span>Available Amount : {{result.quantity | number : '1.3-3'}} {{result.quantityUom}}</span>
                </div>
                <div class='col-12'>
                  <span>TSN : {{result.tsn}}</span>
                </div>
                <div class='col-12'>
                  <span>Sample Use : {{result.sampleUse}} </span>
                </div>
                <div class='col-12'>
                  <span>Purity : {{result.certifiedPurity}} </span>
                </div>
                <div class='col-12'>
                  <span>Certification Date : {{result.certificationDate | date: 'dd-MMM-yyyy'}}</span>
                </div>
                <div class='col-12'>
                  <span>GLP Status : {{result.glpStatus}}</span>
                </div>
                <div class='col-12'>
                  <span>Re-Certification Date : {{result.recertificationDate | date: 'dd-MMM-yyyy'}}</span>
                </div>
                <div class='col-12'>
                  <div class="col-12">
                    <span>Synonyms: </span>
                    <span *ngIf="result.synonyms" class="col-12">{{result.synonyms.join("; ")}}</span>
                  </div>
                </div>
              </div>
              <!-- <div  *ngIf="materialType === 'BioMaterialId' || materialType === 'BioMaterialLotId' || materialType === 'BioNexusSynonymGLP' || materialType === 'BioNexusSynonymStock'">
                <div class='col-12'>
                  <span style="padding-right: 5px;">Material Name: {{result.materialName}}</span>
                  <button pButton type="button" icon="pi pi-list" title="Click icon to view inventory"
                    (click)="getMaterialDetails(result.sourceSystem,result.materialIdInTargetSystem,'mL',getProductName(result))"
                    class="p-button-label"></button>
                </div>
                <div class="col-12" *ngIf="RequestTypeName ===  requestType?.InStock ">
                  <span style="padding-right: 5px;">Material Id: {{result.materialId}}</span>
                </div>
                <div class="col-12" *ngIf="result.lotNumber">
                  <span style="padding-right: 5px;">Material Lot ID: {{result.lotNumber}}</span>
                </div>
                <div class='col-12'>
                  <span> Approver: <a *ngIf="result.approverEmail"
                      href="mailto:{{result.approverEmail}}">{{result.approverFullName == null ? result.approverEmail :
                      result.approverFullName}}</a> </span>
                </div>
                <div class='col-12'
                  *ngIf="materialType === 'BioMaterialLotId' || RequestTypeName ===  requestType?.GLP">
                  <span> Lot Attributes :
                    <div *ngFor="let att of result.lotAttributes" class="grid" style="padding-left: 100px;">
                      <div class="col-3" style="padding-top: 0px !important;padding-bottom:0px !important">
                        {{att.name}}
                      </div>
                      <div class='col-5' style="padding-top: 0px !important;padding-bottom:0px !important">
                        {{att.values}}
                      </div>
                    </div>
                  </span>
                </div>
                <div class='col-12'>
                  <span> Material Attributes : </span>
                </div>
                <div class='col-12'>
                  <div *ngFor="let att of result.materialAttributes" class="col-12" style="padding-left: 100px;">
                    <div class="grid">
                      <div class="col-3" style="padding-top: 0px !important;padding-bottom:0px !important">
                        {{att.name}}
                      </div>
                      <div class='col-5' style="padding-top: 0px !important;padding-bottom:0px !important">
                        {{att.values}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class='col-12'>
                  <span>Synonym:</span>
                  <div class="col-12" *ngFor="let synonym of result.synonyms">
                    <div class="grid" style="padding-left: 50px;">
                      <div class="col-12">{{synonym}}</div>
                    </div>
                  </div>
                </div>
              </div> -->
              <div *ngIf="materialType === 'BioMaterialId' || materialType === 'BioMaterialLotId'|| materialType === 'BioNexusSynonymGLP' || materialType === 'BioNexusSynonymStock'">
                <div class='col-12'>
                  <span style="padding-right: 5px;">Material Name: {{ result.materialName}}</span>
                  <button pButton type="button" icon="pi pi-list" title="Click icon to view inventory"
                    (click)="getMaterialDetails(result.sourceSystem,result.materialIdInTargetSystem,'mL',getProductName(result))"
                    class="p-button-label"></button>
                </div>
                <div class="col-12">
                  <span style="padding-right: 5px;">Scientific Name: {{ getScientificNames(result)}}</span>
                </div>
                <div class='col-12'>
                  <span> GLP Lot Approver:  <a *ngIf="result.approverEmail"
                      href="mailto:{{result.approverEmail}}">{{result.approverFullName == null ? result.approverEmail :
                      result.approverFullName}}</a> </span>
                </div>
                <div class="col-12">
                  <span style="padding-right: 5px;">Material Lot ID: {{result.lotNumber}}</span>
                </div>
                <div class="col-12">
                  <span style="padding-right: 5px;">Sample Use: {{result.sampleUse}}</span>
                </div> 
                <div class="col-12">
                  <span style="padding-right: 5px;">GLP Concentration: {{ getConcentrationUnits(result)}}</span>
                </div>
                <div class="col-12">
                  <span style="padding-right: 5px;">Certification Date: {{ result.certificationDate | date:'yyyy-MM-dd' }}</span>
                </div>
                <div class="col-12">
                  <span style="padding-right: 5px;">GLP Status: {{ result.glpStatus }}</span>
                </div>
                <div class="col-12">
                  <span style="padding-right: 5px;">Re-certification Date: {{ result.recertificationDate | date:'yyyy-MM-dd' }}</span>
                </div>
                <div class='col-12'>
                  <span>Synonym:</span>
                  <div class="col-12" *ngFor="let synonym of result.synonyms">
                    <div class="grid" style="padding-left: 50px;">
                      <div class="col-12">{{synonym}}</div>
                    </div>
                  </div>
                </div>               
              </div>
            </div>

            <div class="col-3">
              <div *ngIf="compositeSearchSettings.showCartButton">
                <div class="col-12 text-right">
                  <span style="color: #d33f49;padding-right: 5px;"
                    *ngIf="(result.discontinued || result.status == 'DISCONTINUED') && (result.quantity && result.quantity > 0)"><b>Discontinued</b><i
                      class="fa fa-close"></i></span>
                  <button pButton type="button" icon="pi pi-shopping-cart" label="Add to Cart"
                    (click)="addToCart(result)" class="p-button-success float-right"
                    [disabled]="(result.status == 'DISCONTINUED' && result.quantity == 0) || result.disabled"
                    *ngIf="!result.isAdded">
                  </button>
                  <button pButton type="button" icon="pi pi-shopping-cart" label="Added to Cart"
                    class="p-button-warning float-right margin-top-0 cursor-no-drop" *ngIf="result.isAdded">
                  </button>
                  <img *ngIf="isBioResult(result)" style="height:35px;" class="float-right"
                    src="assets/primeng/images/bionexus-logo.png" />
                </div>
              </div>
              <div *ngIf="!compositeSearchSettings.showCartButton">
                <div class="col-12">
                  <button pButton type="button" title="Select and proceed to forecast" icon="fa fa-plus fa-3x" label=""
                    (click)="addToCart(result)" class="p-button-success float-right" *ngIf="!result.isAdded">
                  </button>
                  <img *ngIf="isBioResult(result)" style="height:35px;" class="float-right"
                    src="assets/primeng/images/bionexus-logo.png" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="paginatorleft" let-state>
      <span class="ui-paginator-first padding-left-10px"> Total Items : {{results.length}}
        {{ dv.totalRecords == results.length ? '' : '(Showing Items: '+ dv.totalRecords + ')'}} </span>
    </ng-template>
    <ng-template pTemplate="paginatorright" let-state>
      <span class="ui-paginator-first padding-right-10px">{{ dv.totalRecords > 0 ? (state.page * state.rows) + 1 : 0 }}
        -
        {{ (state.rows * (state.page + 1)) > state.totalRecords ? state.totalRecords : (state.rows * (state.page + 1))
        }}
        of {{dv.totalRecords}} Items</span>
    </ng-template>
  </p-dataView>

</div>

<p-dialog id="dialogAddLocation" header="{{materialNameHeader}}" [(visible)]="displayNexusDialog"
  [styleClass]="'clsDialogStyle'" [draggable]="false" [style.minWidth]="'450px'" [style.minHeight]="'450px'"
  [modal]="true" [dismissableMask]="true">
  <div class="inventory-details" [style.minHeight]="'450px'">
  </div>
  <p-footer>
    <div class="row">
      <div class="col-md-10" style="text-align: initial;font-style: italic;"></div>
      <div class="col-md-2"><button type="button" pButton icon="fa fa-close" id="btnCancelPopu"
          (click)="displayNexusDialog=false" label="Close"></button></div>
    </div>
  </p-footer>
</p-dialog>
<p-dialog id="dialogWrongApprover" header="Approver's Email Error" [(visible)]="displayApproverDialog"
  [draggable]="false" [modal]="true" [dismissableMask]="true">
  <div style="width: 600px;">
    <div class="row m-0 p-5">
      <div class="col-md-2">
        <i class="pi pi-info-circle info custom-info"></i>
      </div>
      <div class="col-md-10 p-0" style="font-size: 1rem;">
        Approver's email is not found in the enterprise directory. Please contact repo owner.
      </div>
    </div>
  </div>
  <p-footer>
    <div>
      <button type="button" pButton icon="p-button-icon p-button-icon-left pi pi-check" id="btnCancelPopu"
        (click)="displayApproverDialog=false" label="OK"></button>
    </div>
  </p-footer>
</p-dialog>

<p-dialog id="dialogInventoryModal" header="{{materialNameHeader}}" [(visible)]="displayDialog"
  [styleClass]="'clsDialogStyle'" [draggable]="false" [style.width]="'1050px'" [style.minWidth]="'600px'"
  [style.minHeight]="'600px'" [modal]="true" [dismissableMask]="'true'">
  <div class="inventory-details" style="background-color: lightgrey;">
    <div id="inventory-breakdown-div">
      <table *ngIf="this.materialInfo" id="inventory-breakdown">
        <tr>
          <th></th>
          <th></th>
          <th>Physical</th>
          <th>Reserved</th>
          <th>Available</th>
        </tr>
        <tbody>
          <tr>
            <td rowspan=3 class="mi-bold">Stock</td>
            <td>Indianapolis</td>
            <td>{{this.inventoryBreakDown.STOCK.INDY.physical | number : '1.3-3' }} {{inventoryUOM}}</td>
            <td>{{this.inventoryBreakDown.STOCK.INDY.reserved | number : '1.3-3' }} {{inventoryUOM}}</td>
            <td>{{this.inventoryBreakDown.STOCK.INDY.available| number : '1.3-3' }} {{inventoryUOM}}</td>
          </tr>
          <tr>
            <td>{{ euCenterFeature ? "France" : "SGS" }}</td>
            <td *ngIf="euCenterFeature">{{this.inventoryBreakDown.STOCK.FRANCE.physical | number : '1.3-3' }}
              {{inventoryUOM}}</td>
            <td *ngIf="euCenterFeature">{{this.inventoryBreakDown.STOCK.FRANCE.reserved | number : '1.3-3' }}
              {{inventoryUOM}}</td>
            <td *ngIf="euCenterFeature">{{this.inventoryBreakDown.STOCK.FRANCE.available | number : '1.3-3' }}
              {{inventoryUOM}}</td>

            <td *ngIf="!euCenterFeature">{{this.inventoryBreakDown.STOCK.SGS.physical | number : '1.3-3' }}
              {{inventoryUOM}}</td>
            <td *ngIf="!euCenterFeature">{{this.inventoryBreakDown.STOCK.SGS.reserved | number : '1.3-3' }}
              {{inventoryUOM}}</td>
            <td *ngIf="!euCenterFeature">{{this.inventoryBreakDown.STOCK.SGS.available | number : '1.3-3' }}
              {{inventoryUOM}}</td>
          </tr>
          <tr class="mi-bold">
            <td>Sub-Total</td>
            <td>{{this.inventoryBreakDown.STOCK.SUB.physical | number : '1.3-3' }} {{inventoryUOM}}</td>
            <td>{{this.inventoryBreakDown.STOCK.SUB.reserved | number : '1.3-3' }} {{inventoryUOM}}</td>
            <td>{{this.inventoryBreakDown.STOCK.SUB.available | number : '1.3-3' }} {{inventoryUOM}}</td>
          </tr>
        </tbody>
        <tbody
          [hidden]="this.materialType == this.commonService.configurations?.Coformulant || this.materialType == this.commonService.configurations?.FieldInert">
          <tr>
            <td rowspan=3 class="mi-bold">GLP</td>
            <td>Indianapolis</td>
            <td>{{this.inventoryBreakDown.GLP.INDY.physical | number : '1.3-3' }} {{inventoryUOM}}</td>
            <td>{{this.inventoryBreakDown.GLP.INDY.reserved | number : '1.3-3' }} {{inventoryUOM}}</td>
            <td>{{this.inventoryBreakDown.GLP.INDY.available | number : '1.3-3' }} {{inventoryUOM}}</td>
          </tr>
          <tr>
            <td>{{ euCenterFeature ? "France" : "SGS" }}</td>
            <td *ngIf="euCenterFeature">{{this.inventoryBreakDown.GLP.FRANCE.physical | number : '1.3-3' }}
              {{inventoryUOM}}</td>
            <td *ngIf="euCenterFeature">{{this.inventoryBreakDown.GLP.FRANCE.reserved | number : '1.3-3' }}
              {{inventoryUOM}}</td>
            <td *ngIf="euCenterFeature">{{this.inventoryBreakDown.GLP.FRANCE.available | number : '1.3-3' }}
              {{inventoryUOM}}</td>

            <td *ngIf="!euCenterFeature">{{this.inventoryBreakDown.GLP.SGS.physical | number : '1.3-3' }}
              {{inventoryUOM}}</td>
            <td *ngIf="!euCenterFeature">{{this.inventoryBreakDown.GLP.SGS.reserved | number : '1.3-3' }}
              {{inventoryUOM}}</td>
            <td *ngIf="!euCenterFeature">{{this.inventoryBreakDown.GLP.SGS.available | number : '1.3-3' }}
              {{inventoryUOM}}</td>
          </tr>
          <tr class="mi-bold">
            <td>Sub-Total</td>
            <td>{{this.inventoryBreakDown.GLP.SUB.physical | number : '1.3-3' }} {{inventoryUOM}}</td>
            <td>{{this.inventoryBreakDown.GLP.SUB.reserved | number : '1.3-3' }} {{inventoryUOM}}</td>
            <td>{{this.inventoryBreakDown.GLP.SUB.available | number : '1.3-3' }} {{inventoryUOM}}</td>
          </tr>
        </tbody>
        <tbody
          [hidden]="this.materialType == this.commonService.configurations?.Coformulant || this.materialType == this.commonService.configurations?.FieldInert">
          <tr class="mi-bold">
            <td>Grand Total</td>
            <td></td>
            <td> {{materialInfo.totalPhysical | number : '1.3-3' }} {{inventoryUOM}}</td>
            <td> {{ (materialInfo.totalIndyReserved + (euCenterFeature ? materialInfo.totalFranceReserved :
              materialInfo.totalSGSReserved )) | number : '1.3-3' }} {{inventoryUOM}}</td>
            <td> {{ inventoryTotalAvailable | number : '1.3-3' }} {{inventoryUOM}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="grid" style="margin-left:1px;margin-top:1px;">
      <div class="inventory-disclaimer">
        <div class="grid">
          <!-- <div class="col-12"  style="text-align: center;font-weight: bold;color: black;vertical-align:middle;">
        <span style="font-weight: bold;text-decoration: underline;">Disclaimer:</span>
      </div> -->
          <div class="col-offset-1 col-10"
            style="text-align: center;line-height: normal;color: black;padding-left:5px; padding-right: 5px;">
            <span><strong>Disclaimer:</strong>"Total Available" and sum of "Available Qty." may not equal one another.
              The quantity under "Total Available" shows the current amount available to order in CPSS (without a
              forecast). "Total Available" accounts for all reservations for this material. "Available Qty." by lot
              only, as shown below, accounts for reservations sent for that particular lot, and does not account for
              reservations sent without a specific lot assigned.</span>
          </div>
        </div>
      </div>
    </div>
    <div class="grid" style="margin-top:10px;">
      <div class="col-2">
        <label style="font-weight: bold;">*Unit of Measure</label>
      </div>
      <div class="col-5">
        <p-selectButton [(ngModel)]="selectedUom" (onChange)="OnUnitOfMeasureChange($event)" [options]="uomOptions"
          optionLabel="UnitOfMeasure" id="selectButtonOrderItemctrnUOM"></p-selectButton>
      </div>
      <div class="col-3">
        <p-selectButton [options]="inventoryList" [(ngModel)]="selectedInventoryType" optionLabel="name"
          optionValue="value"></p-selectButton>
      </div>
      <div class="col-2">
        <button type="button" pButton icon="pi pi-download" pTooltip="Download Reconciliation Report" class="btn-icons"
          style="margin-left: 1px;" id="btnDownload" *ngIf="isAdmin" tooltipPosition="bottom"
          (click)="downloadReconcileReport()"></button>
        <button type="button" pButton icon="pi pi-refresh" [disabled]="true" pTooltip="Click to Reconcile"
          class="btn-icons" id="btnRefresh" style="margin-left: 1px;" *ngIf="isAdmin" tooltipPosition="bottom"
          (click)="reconcileAndRefresh()"></button>
      </div>

    </div>
    <p-table #dtLot [columns]="cols" [value]="materialInfo?.compositeInventoryByLot">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngIf="SelectedRepo=='FACTS' || SelectedRepo == 'COFORM' || SelectedRepo == 'BIONEXUS'"
            pSortableColumn="lotNumber"> Lot No <p-sortIcon field="lotNumber"></p-sortIcon>
          </th>
          <th *ngIf="SelectedRepo=='CORE'" pSortableColumn="lotId"> Lot No <p-sortIcon field="lotId"></p-sortIcon>
          </th>
          <th pSortableColumn="manufacturerLotNumber"> Mfg Lot No <p-sortIcon field="manufacturerLotNumber">
            </p-sortIcon>
          </th>
          <th pSortableColumn="dateOfManufacture"> Date of Mfg <p-sortIcon field="dateOfManufacture"></p-sortIcon>
          </th>
          <th pSortableColumn="inventoryType"> Inventory Type <p-sortIcon field="inventoryType"></p-sortIcon>
          </th>
          <th pSortableColumn="inventoryLocation"> Warehouse Loc. <p-sortIcon field="inventoryLocation"></p-sortIcon>
          </th>
          <th pSortableColumn="expirationDate"> Exp Date <p-sortIcon field="expirationDate"></p-sortIcon>
          </th>
          <th pSortableColumn="available" style="text-align: right !important;"> Available Qty <p-sortIcon
              field="available"></p-sortIcon>
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr
          *ngIf="rowData['available'] != '0'&&(rowData['glpStatus'].toString().toLowerCase()==='stock'||isGlpEligible)
      && ((selectedInventoryType == 'STOCK' && rowData['inventoryType'].toLowerCase().includes('stock')) || (selectedInventoryType == 'GLP' && rowData['inventoryType'].toLowerCase().includes('glp')) || (selectedInventoryType == 'BOTH')) ">
          <td>
            <span *ngIf="SelectedRepo=='FACTS' || SelectedRepo == 'COFORM' || SelectedRepo == 'BIONEXUS'">{{
              rowData['lotNumber'] }}</span>
            <span *ngIf="SelectedRepo=='CORE' ">{{ rowData['lotId'] }}</span>
          </td>
          <td>
            {{ rowData['manufacturerLotNumber'] }}
          </td>
          <td>
            {{ rowData['dateOfManufacture'] | date:"dd-MMM-yyyy" :'UTC'}}
          </td>
          <td>
            {{ rowData['inventoryType'] }}
          </td>
          <td>
            {{ euCenterFeature ? rowData['inventoryLocation'] : rowData['inventoryLocation'] == "Indy" ? "Indianapolis"
            : rowData['inventoryLocation'] }}
          </td>
          <td>
            {{ rowData['expirationDate'] | date:"dd-MMM-yyyy" :'UTC'}}
          </td>
          <td style="text-align: right !important;">
            {{(rowData['available'] < 0 ? 0 : rowData['available']) | number : '1.3-3' }} {{inventoryUOM}} </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <p-footer>
    <div class="row">
      <div class="col-md-10" style="text-align: initial;font-style: italic;"></div>
      <div class="col-md-2"><button type="button" pButton icon="fa fa-close" id="btnCancelPopup"
          (click)="displayDialog=false" label="Close"></button></div>
    </div>
  </p-footer>
</p-dialog>